import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {setFilter} from '../Store/creators/filter';
import {setBuilding} from '../Store/creators/visualData';
import {dispatch} from '../Store/index';
import {StateVisualBuilding} from '../Store/State';
import sendVisualRequest from '../utils/sendVisualRequest';

// tslint:disable:max-line-length
const data = {
	front: {
		building: '1',
		view: 'front',
		nextView: '',
		image: '/images/choose-visual/building/01.jpg',
		map: [
			{
				path: 'M748.1 596.3L477 689l-46.4-45.4L395 167l287.1 17.2 1.9.7v4.4l41.9 20.5 9.7.4 2.4.8 1 34.7z',
				target: '1.1',
				available: 1,
			},
			{
				path: 'M926.3 279.1v256.2l-178.2 61-9.1-350.6 131.7 6.3.6 15.1 25.7 11.2z',
				target: '1.2',
				available: 1,
			},
			{
				path: 'M1081 200l-4.2 283.8-150.5 51.5V279.1l-29.3-.8-25.7-11.2-.6-15.1 7.9.4 141.2-74.1v21.5l34.9 14.3z',
				target: '1.3',
				available: 1,
			},
			{
				path: 'M1252.4 197.4l-17.4 4.7.2 9.1-12 4.1-35-22.2-7.2 290.2-41.3-21-62.9 21.5L1081 200l-26.3 14.1-34.9-14.3v-21.5L1146 112l106.7 63.8z',
				target: '1.4',
				available: 1,
			},
			{
				path: 'M1415 272.7l-.7 23.4-38.2 14.9-21.9-14-12.8 267.9-160.4-81.6 7.2-290.2 35 22.2 12-4.1-.2-9.1 17.4-4.7.3-21.6z',
				target: '1.5',
				available: 1,
			},
			{
				path: 'M1555 323l-26 317-51 24-57 3-60.9-92.6-18.7-9.5 12.8-267.9 21.9 14 38.2-14.9.7-23.4 57.1 34.1 17.2.5 6.5 5.5z',
				target: '1.6',
				available: 1,
			},
		],
	},
};

async function fetchVisualBuilding( building: string, view: string ): Promise<void>
{
	if ( building === '2' )
	{
		dispatch(
			setBuilding(
				{
					building: '2',
					view: 'front',
					nextView: '',
					image: '/images/choose-visual/overview/01.jpg',
					map: [],
				},
			),
		);
		
		return;
	}
	
	dispatch( setLoading( true ) );
	
	const serverData = await sendVisualRequest( {buildingView: view, building} );
	
	if ( !( view in data ) )
	{
		view = 'front';
	}
	
	const viewData = {...(data as any)[view]} as StateVisualBuilding;
	
	if ( serverData.building && serverData.building.map )
	{
		const sections = new Map<string | number, number>();
		
		for ( const item of serverData.building.map )
		{
			sections.set( item.target, item.available );
		}
		
		for ( const item of viewData.map )
		{
			if ( sections.has( item.target ) )
			{
				// tslint:disable-next-line:no-non-null-assertion
				item.available = sections.get( item.target )!;
			}
			else
			{
				item.available = 0;
			}
		}
	}
	
	// TODO:
	dispatch(
		setFilter( serverData.filter ),
	);
	
	dispatch( setBuilding( viewData ) );
	
	dispatch( setLoading( false ) );
}

const debouncedFetchVisualBuilding = debounce( fetchVisualBuilding, 200 );

/**
 * Module.
 */
export {
	fetchVisualBuilding as default,
	debouncedFetchVisualBuilding,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchVisualBuilding.ts